@if (HasRequiredPermissions) {
@if (hasWebSocketChanges()) {
<div class="absolute top-[3.2em] right-[1.5em] px-3 py-0 bg-yellow-50 border border-yellow-500 rounded-lg flex items-center justify-between z-50">
  <span class="text-xs text-yellow-800">
    {{ 'Record ' | translate }} {{ 'modified' | translate }}.
    ({{ totalModifiedCount() }} {{ 'changes' | translate }})
  </span>
</div>
}
@if (EntityInstance || isNew()) {
<!-- Conteneur principal avec layout flexbox -->
<div [fieldContext]="this" class="flex flex-col h-full">
  <!-- Titre fixe en dehors de la zone de défilement -->
  <div class="px-6 pt-4 pb-2">
    <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
      @if (isNew()) {
      {{ 'entities.employee.newEntity' | translate }}
      } @else {
      {{ 'entities.employee.detailEntity' | translate }}
      }
    </h4>
    <div class="flex justify-between items-center">
      <button (click)="cancelEdit()" data-testid="detail-close" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
  <!-- Personal Info Section -->
  <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
    <!--  Conteneur desactivable -->
    <div class="{{this.UpdateMode}}">
      <!-- Activity Information Section -->
      <div class="">
        <h3 class="{{Skin.formSectionSmallTitle}}">
          <i class="fa fa-user mr-2"></i> {{
          'vues.employee.detail.sections.personal-info' | translate
          }}
        </h3>
        <div class="space-y-2">
          <!-- Photo Upload (spécifique) -->
          <div class="relative m-6 w-[140px] h-[180px] mt-2 ml-16 border border-gray-300 overflow-hidden rounded-[10px] border-[3px] border-gray-100 shadow-[0_7px_7px_rgba(0,0,0,0.1)]">
            <i class="far fa-user absolute inset-0 text-gray-400 text-[120px] flex items-center justify-center pointer-events-none" [ngClass]="{'hidden': imageUrl}"></i>
            <img [src]="imageUrl || ''" class="w-full h-full object-cover" [ngClass]="{'hidden': !imageUrl}" />
            <div class="absolute bottom-0 left-0 flex">
              <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event,'FK_Image_Photo')" class="hidden" />
              <button type="button" (click)="fileInput.click()" class="bg-teal-500 hover:bg-teal-800 text-white px-2 py-1 text-xs font-xs">
                <i class="fa fa-camera text-[0.9rem]"></i>
              </button>
              <button type="button" (click)="resetImage()" class="{{Skin.btnAlert}} px-2 py-1 text-xs font-xs">
                <i class="fas fa-times text-[0.9rem]"></i>
              </button>
            </div>
          </div>
          <!-- Champ selectedPK_Pos (multi-select) -->
          <app-field-wrapper property="selectedPK_Pos" businessProperty="employeePOS" label="entities.account.propreties.pos">
            <app-multi-select #multiSelect
              [options]="pointOfServiceLookup()"
              [placeholder]="'Select Sites'"
              [maxItems]="0"
              [selectedKeys]="editingEntity()?.selectedPK_Pos || []"
              (selectedKeysChange)="onPOSselectChange($event)"
              onReady
              (autoBind)="bindingHandler($event, 'selectedPK_Pos', multiSelect)">
            </app-multi-select>
          </app-field-wrapper>
          <!-- Champ firstName -->
          <app-field-wrapper property="firstName">
            <input type="text" autocomplete="off" onReady

              class="{{Skin.formInputSmallSize}}"
              (autoBind)="bindingHandler($event, 'firstName')">
          </app-field-wrapper>
          <!-- Champ lastName -->
          <app-field-wrapper property="lastName">
            <input type="text" autocomplete="off" onReady

              class="{{Skin.formInputSmallSize}}"
              (autoBind)="bindingHandler($event, 'lastName')">
          </app-field-wrapper>
          <!-- Champ employeeID -->
          <app-field-wrapper property="employeeID">
            <input type="text" autocomplete="off" onReady

              class="{{Skin.formInputSmallSize}}"
              (autoBind)="bindingHandler($event, 'employeeID')">
          </app-field-wrapper>
          <!-- Champ email -->
          <app-field-wrapper property="email">
            <input type="email" autocomplete="off" onReady

              class="{{Skin.formInputSmallSize}}"
              (autoBind)="bindingHandler($event, 'email')">
          </app-field-wrapper>
          <!-- Champ phoneNumber -->
          <app-field-wrapper property="phoneNumber">
            <input type="tel" autocomplete="off" onReady

              class="{{Skin.formInputSmallSize}}"
              (autoBind)="bindingHandler($event, 'phoneNumber')">
          </app-field-wrapper>
          <!-- Champ fK_Language (select) -->
          <app-field-wrapper property="fK_Language" label="entities.employee.propreties.language">
            <select onReady

              class="{{Skin.formInputSmallSize}}"
              (autoBind)="bindingHandler($event, 'fK_Language')">
              <option [value]="null" disabled>{{ 'Choose a Language' | translate }}</option>
              @for (languageOption of languageLookup(); track languageOption.key) {
              <option [value]="languageOption.key">{{ `languages.${languageOption.value}` | translate }}</option>
              }
            </select>
          </app-field-wrapper>
          <!-- Champ isManager (checkbox) -->
          <app-field-wrapper property="isManager">
            <input type="checkbox" onReady

              class="h-4 w-4 text-indigo-600 rounded focus:ring-indigo-500"
              (autoBind)="bindingHandler($event, 'isManager')">
          </app-field-wrapper>
          <!-- Champ fK_Manager (select) -->
          <app-field-wrapper property="fK_Manager" label="entities.employee.propreties.manager">
            <select
              class="{{Skin.formInputSmallSize}}"
              [ngModel]="editingEntity()?.fK_Manager ?? null"
              (ngModelChange)="updateEditingEntity('fK_Manager', $event)">
              <option [ngValue]="null"></option>
              @for (managerOption of managerLookup(); track managerOption.id) {
              <option [ngValue]="managerOption.id">{{ managerOption.value }}</option>
              }
            </select>
          </app-field-wrapper>
          <!-- Champ status (reactive-badge) -->
          <app-field-wrapper property="status">
            <app-reactive-badge [lookupData]="employeeStatusLookup()"
              [status]="$safeNavigationMigration(editingEntity()?.status)"
              [Skin]="Skin"
              [isEditMode]="true"
              (statusChange)="updateEntityProperty2('status', $event)">
            </app-reactive-badge>
          </app-field-wrapper>
          <!-- Champ aDId (readonly) -->
          <app-field-wrapper property="aDId" label="entities.employee.propreties.adId">
            <input type="text" autocomplete="off" readonly onReady

              class="{{Skin.formInputSmallSize}} bg-gray-100"
              (autoBind)="bindingHandler($event, 'aDId')">
          </app-field-wrapper>
          <!-- Champ qrCode (readonly) -->
          <app-field-wrapper property="qrCode" label="entities.employee.propreties.qrCodeId">
            <input type="text" autocomplete="off" readonly onReady

              class="{{Skin.formInputSmallSize}} bg-gray-100"
              (autoBind)="bindingHandler($event, 'qrCode')">
          </app-field-wrapper>
          <!-- Download QR-Code Button (inchangé) -->
          <div>
            <button type="button" (click)="downloadQrCode()" class="{{Skin.secondary}} uppercase py-2 px-2">
              <i class="fas fa-qrcode mr-2"></i>
              {{ 'buttons.download-qr-code' | translate }}
            </button>
          </div>
          <!-- Create Account Button (inchangé) -->
          <div>
            <button type="button" (click)="createAccount()" class="{{Skin.btnPrimary}} uppercase py-2 px-2">
              <i class="fas fa-user-plus mr-2"></i>
              {{ 'buttons.create-account' | translate }}
            </button>
          </div>
        </div>
      </div>
      <!-- Send Notification Section -->
      <div class="mt-10">
        <h3 class="{{Skin.formSectionSmallTitle}}"><i class="fas fa-envelope mr-2"></i> {{ 'vues.employee.detail.sections.send-notification' | translate }}</h3>
        <div class="space-y-2">
          <!-- Champ emailNotification (checkbox) -->
          <app-field-wrapper property="emailNotification">
            <input type="checkbox" onReady

              class="h-4 w-4 text-indigo-600 rounded focus:ring-indigo-500"
              (autoBind)="bindingHandler($event, 'emailNotification')">
          </app-field-wrapper>
          <!-- Champ smsNotification (checkbox) -->
          <app-field-wrapper property="smsNotification">
            <input type="checkbox" onReady

              class="h-4 w-4 text-indigo-600 rounded focus:ring-indigo-500"
              (autoBind)="bindingHandler($event, 'smsNotification')">
          </app-field-wrapper>
          <!-- Champ slackNotification (checkbox) -->
          <app-field-wrapper property="slackNotification">
            <input type="checkbox" onReady

              class="h-4 w-4 text-indigo-600 rounded focus:ring-indigo-500"
              (autoBind)="bindingHandler($event, 'slackNotification')">
          </app-field-wrapper>
          <!-- Champ teamsNotification (checkbox) -->
          <app-field-wrapper property="teamsNotification">
            <input type="checkbox" onReady

              class="h-4 w-4 text-indigo-600 rounded focus:ring-indigo-500"
              (autoBind)="bindingHandler($event, 'teamsNotification')">
          </app-field-wrapper>
        </div>
      </div>
      <!-- Personal Info to Approve Section -->
      <div class="mt-10">
        <h3 class="{{Skin.formSectionSmallTitle}}"><i class="fas fa-user mr-2"></i> {{ 'vues.employee.detail.sections.personal-info-to-approve' | translate }}</h3>
        <div class="space-y-2">
          <!-- Champ emailTemp (readonly) -->
          <app-field-wrapper property="emailTemp">
            <input type="text" autocomplete="off" readonly onReady

              class="{{Skin.formInputSmallSize}} bg-gray-100"
              (autoBind)="bindingHandler($event, 'emailTemp')">
          </app-field-wrapper>
          <!-- Champ phoneNumberTemp (readonly) -->
          <app-field-wrapper property="phoneNumberTemp">
            <input type="text" autocomplete="off" readonly onReady

              class="{{Skin.formInputSmallSize}} bg-gray-100"
              (autoBind)="bindingHandler($event, 'phoneNumberTemp')">
          </app-field-wrapper>
        </div>
      </div>
    </div>
  </div>
  <!-- Bandeau pour le nombre d'erreurs -->
  @if (generalErrorCount() > 0) {
  <div class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
    <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
    {{ generalErrorCount() }} erreur(s) dans le formulaire
  </div>
  }
  <!-- Boutons en bas du formulaire -->
  <div class="bg-stone-50 min-w-full flex space-x-1 justify-center pt-2 border-t border-gray-200">
    @if (HasEditPermission) {
    <button name="SaveButton" data-testid="detail-save"
      type="button" (click)="saveItem()"
      [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save' | translate }}
    </button>
    }
    @if (HasEditPermission) {
    <button name="SaveAndCloseButton" data-testid="detail-save-close"
      type="button" (click)="saveAndCloseItem()"
      [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save-and-close' | translate }}
    </button>
    }
    <button (click)="cancelEdit()" data-testid="detail-cancel"
      class="{{Skin.btnAlert}} uppercase py-2 px-2">
      <i class="fas fa-times mr-2"></i>
      {{ 'buttons.cancel' | translate }}
    </button>
  </div>
</div>
}
}